// extracted by mini-css-extract-plugin
export default {"block":"OMNhP5","text":"vaoRZa","flicker":"BYEbJz"};